import React from 'react';
import { useLoaderData } from 'react-router-dom';
import Hero from '../Hero/Hero';
import Quiz from '../Quiz/Quiz';


const Home = () => {
    const items = useLoaderData();

    return (
        <section>
            <div className="hero-area">
                <Hero></Hero>
            </div>
            <div className="quiz-area">
                <div className="py-6 dark:bg-gray-800 dark:text-gray-100 mt-1">
                    <div className="container p-4 mx-auto space-y-16 sm:p-10">
                        <div className="space-y-4 text-center">
                            <h3 className="text-2xl font-bold leading-none sm:text-4xl">Our Quiz Context</h3>
                            <p className="max-w-2xl mx-auto dark:text-gray-400">This is an important feature of us. We always try to do better for our clients and followers. For this reason we provider our well wishers to improve their knowledge in the field of programming. For the best reason here is offer a simple and advanced Quiz Context. Best wishes for you. </p>
                        </div>
                        <div className="grid w-full grid-cols-1 gap-x-6 gap-y-12 sm:grid-cols-2 lg:grid-cols-4">

                            {
                                items.data.map(item => <Quiz
                                    key={item.id}
                                    item={item}
                                ></Quiz>)
                            }
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Home;